import type { Conversation } from "@lumen/shared";

export function applyConversationSeen(
  current: Conversation[],
  conversationId: string,
  messageId: string,
): Conversation[] {
  // A seen response acknowledges read state only. Its other fields may
  // predate a newer sidebar refresh or completion.
  return current.map((item) =>
    item.id === conversationId &&
    item.attention === "response-ready" &&
    item.attentionMessageId === messageId
      ? {
          ...item,
          lastSeenMessageId: messageId,
          attention: null,
          attentionMessageId: null,
        }
      : item,
  );
}
